import React from "react";
import { IRemoteAuthData } from "../SignIn/reducer";
import {
  IRecipientTicketInfo,
  ShareStatus
} from "../../../interface/IShareInfo";
import { HeadingSection } from "./HeadingSection";
import { TicketInfoPanelV2 } from "../../TicketInfoPanel/TicketInfoPanelV2";
import { SeatInfo } from "../../TicketInfoPanel/SeatInfoV2";
import { ButtonGroup } from "./ButtonGroup";
import { LegalInfo } from "./LegalInfo";

interface IProps {
  loading: boolean;
  data: IRecipientTicketInfo;
  authData: IRemoteAuthData;
  firstAccepted: boolean;
}

export const TicketReceivingContent = ({
  loading,
  data,
  authData,
  firstAccepted
}: IProps) => {
  const view_ticket_page = data && data.shareStatus === ShareStatus.Accepted;
  return (
    <div>
      <HeadingSection
        loading={loading}
        recipientTicketInfo={data}
        isAuthenticated={authData.isAuthenticated}
      />
      {!view_ticket_page && (
      <div  style={{display:'none'}}>
        <TicketInfoPanelV2 loading={loading} venueInfo={data && data.venueInfo}>
            <SeatInfo loading={loading} seatInfo={data && data.seatInfo} />
        </TicketInfoPanelV2>
      </div>
      )}

      {!firstAccepted && <LegalInfo />}
      <ButtonGroup
        loading={loading}
        recipientTicketInfo={data}
        isAuthenticated={authData.isAuthenticated}
      />
    </div>
  );
};
